import { render } from "./MatchPairSentenceSlotExerciseComponent.vue?vue&type=template&id=b419570a&scoped=true"
import script from "./MatchPairSentenceSlotExerciseComponent.vue?vue&type=script&lang=js"
export * from "./MatchPairSentenceSlotExerciseComponent.vue?vue&type=script&lang=js"

import "./MatchPairSentenceSlotExerciseComponent.vue?vue&type=style&index=0&id=b419570a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b419570a"]])

export default __exports__